import { Link, useSearchParams } from "react-router-dom";

import { Button } from "@/shared/ui/button/Button";

import { AuthCard, AuthShell } from "./AuthShell";

/**
 * Why the user landed here. The reason comes from whoever redirected them, so
 * a deactivated account is told what actually happened instead of the generic
 * "your session expired" — retrying would not help them.
 */
const REASONS: Record<string, { title: string; message: string }> = {
  inactive: {
    title: "Account deactivated",
    message:
      "This account is no longer active. Contact your administrator to have it switched back on.",
  },
  session: {
    title: "Session ended",
    message: "Your session has ended. Sign in again to continue.",
  },
};

const DEFAULT_REASON = {
  title: "No access",
  message: "You do not have permission to open that page.",
};

export function UnauthorizedView() {
  const [params] = useSearchParams();
  const { title, message } = REASONS[params.get("reason") ?? ""] ?? DEFAULT_REASON;

  return (
    <AuthShell>
      <AuthCard title={title} subtitle={message}>
        <Button asChild size="lg" className="w-full">
          <Link to="/login">Go to sign in</Link>
        </Button>
      </AuthCard>
    </AuthShell>
  );
}
